import { Component, inject, OnDestroy } from '@angular/core';
import { FormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UserService } from '../core/services/user.service';
import { TranslateModule } from '@ngx-translate/core';
import { LottieComponent } from 'ngx-lottie';
import { Subject, takeUntil } from 'rxjs';
import { FeedbackService } from '../core/services/feedback.service';
import { AsyncPipe } from '@angular/common';
import { CustomInputComponent } from '@shared/components/custom-input/custom-input.component';

@Component({
  selector: 'app-feedback-popup',
  templateUrl: './feedback-popup.component.html',
  styleUrl: './feedback-popup.component.scss',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CustomInputComponent,
    LottieComponent,
    TranslateModule,
    AsyncPipe,
  ],
})
export class FeedbackPopupComponent implements OnDestroy {
  private userService = inject(UserService);
  private fb = inject(FormBuilder);
  private feedbackService = inject(FeedbackService);
  private destroy$ = new Subject<void>();

  feedbackForm = this.fb.group({
    feedback: ['', Validators.required],
  });
  showFeedbackGreeting = false;
  showFeedbackModal$ = this.feedbackService.showFeedbackModal$;
  animationOptions = {
    path: '/assets/animations/RateAnimation.json',
    loop: true,
  };
  animationStyles: Partial<CSSStyleDeclaration> = {
    height: '150px',
  };

  onSubmit() {
    if (this.feedbackForm.valid) {
      this.userService
        .sendFeedback(this.feedbackForm.value.feedback)
        .pipe(takeUntil(this.destroy$))
        .subscribe(res => {
          this.showFeedbackGreeting = true;
          setTimeout(() => {
            this.showFeedbackGreeting = false;
            this.onCloseFeedbackModal();
          }, 3000);
        });
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onCloseFeedbackModal() {
    this.feedbackForm.reset();
    this.feedbackForm.markAsPristine();
    this.feedbackForm.markAsUntouched();
    Object.keys(this.feedbackForm.controls).forEach(key => {
      this.feedbackForm.get(key)?.setErrors(null);
    });
    this.showFeedbackGreeting = false;
    this.feedbackService.closeFeedbackModal();
  }
}
